import NoMatch from "components/no-match"
import AuthLayout from "modules/layout/auth"
import { Routes, Route, Navigate } from "react-router-dom"
import ExternalMembers from "./member"

const External: React.FC = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route index element={<Navigate to="members" />} />
        <Route path="members/*" element={<ExternalMembers />} />

        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  )
}

export default External
